import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function provideAppIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      const reg = inject(MatIconRegistry);
      const dom = inject(DomSanitizer);
      reg.addSvgIconSetInNamespace(
        'custom',
        dom.bypassSecurityTrustResourceUrl('assets/icons/icons-sprite.svg')
      );
      reg.addSvgIconSetInNamespace(
        'nav',
        dom.bypassSecurityTrustResourceUrl('assets/icons/icons-nav-sprite.svg')
      );
      reg.addSvgIconSetInNamespace(
        'snackbar',
        dom.bypassSecurityTrustResourceUrl('assets/icons/icons-snackbar.svg')
      );
      reg.addSvgIconSetInNamespace(
        'keysNumbers',
        dom.bypassSecurityTrustResourceUrl('assets/icons/icons-keys-numbers-profile.svg')
      );
    }),
  ]);
}
